import { render } from "./documents.vue?vue&type=template&id=585db6c3&ts=true"
import script from "./documents.vue?vue&type=script&lang=ts"
export * from "./documents.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__